// extracted by css-extract-rspack-plugin
export default {"form":"Ar2kqxsKrTsGGxpJ__form___","filterSection":"nV21lx9ZOM1xEVWk__filterSection___"};